import Sprite = PIXI.Sprite;
import Container = PIXI.Container;
import { Back, TweenLite } from 'gsap';
import { getGameSize } from '../../Config/Levels';
import { gameConfig } from '../../index';
import { Popup } from '../../Managers/Popups';
import { ITweenable } from './ITweenable';
import { PopupHeader } from './PopupHeader';
import NineSlicePlane = PIXI.mesh.NineSlicePlane;
import { Animation } from '../Animations/Animation';

export class CharacterPopup extends Container implements ITweenable {
    protected header: PopupHeader;
    protected bg: NineSlicePlane;
    protected yOffset: number = 0;
    constructor(
        width: number,
        height: number,
        charImage: string,
        headerText: string,
        popupType: Popup
    ) {
        super();
        const texture = PIXI.utils.TextureCache['commonui/popup-bg'];
        const bg = new NineSlicePlane(texture, 100, 100, 100, 100);
        bg.width = width;
        bg.height = height;
        this.bg = bg;

        const char = new Sprite(PIXI.utils.TextureCache[charImage]);
        char.anchor.set(0.5, 0.5);
        char.x = width / 2;
        char.y -= char.height * 0.1;

        const header = new PopupHeader(headerText, popupType, 1);
        header.x = width / 2;
        header.y = char.y + char.height * 0.3;
        this.header = header;

        //@ts-ignore
        this.addChild(bg, char, header);
    }

    public async tweenIn(duration = 0.7): Promise<void> {
        const gameSize = getGameSize();
        const animation = new Animation({});
        animation.add(() => this.header.tweenIn(0.1));
        animation.addToLast(
            TweenLite.fromTo(
                this,
                0.6,
                {
                    y: gameConfig.game_height + this.height / 2,
                },
                {
                    ease: Back.easeOut.config(1),
                    y: gameSize.yOffset + gameConfig.game_height * 0.25 - this.yOffset,
                }
            )
        );
        await animation.play();
    }

    public tweenOut(...args: Array<unknown>): void {
        const gameSize = getGameSize();
        this.header.tweenOut();
        TweenLite.to(this, 0.2, {
            y: gameSize.gameHeight + this.height,
            onComplete: () => this.destroy(),
        });
    }
}
